// extracted by mini-css-extract-plugin
export default {"tagContainer":"grid-stock-image-item-module__tagContainer--TDWfv","thumb":"grid-stock-image-item-module__thumb--AudqC"};